import React, { Component } from 'react';
import { Container, Accordion, Icon, Label, Button, Header, Modal } from 'semantic-ui-react';
import { PtInput, PtInputShort, PtInputIcon, PtInputIconWaypoint, EditGeographicPoint } from '../../grit-utilities';
import 'semantic-ui-css/semantic.min.css';
import '../../index.css';
import ScrollArea from 'react-scrollbar';

/*const waypointstuff = [
    { lat: 46.897753, lng: -96.802437 },
    { lat: 46.897753, lng: -96.802437 },
    { lat: 46.897753, lng: -96.802437 }
];*/

const limitPoints = 23;

export default class Route extends Component {
    constructor(props) {
        super(props);
        this.state = this.props.routeModel;
    }
    /* although this is deprecated, in order to set state for these in here like this
    * I had to create the componentWillMount method. Can't set state in constructor
    * and cannot set it in render because that is anti-pattern. This should work, though.
    * at least it appears to. - Elliot Thompson 06/08/2021*/
    componentWillMount() {
        this.setState({
            triggerIsPolyModal: false
        });
        this.setState({
            triggerEditLatLng: false
        });
        this.setState({
            limitPoints: limitPoints
        });
    }

    render() {
        const { onClickStart, onClickEnd, onWaypointPlot, onCheckOverlapping } = this.props.clickFunctions;
        const startState = (pos, snapped) => {
            const start = `${pos.lat}, ${pos.lng}`;
            this.setState({ start: start });
            this.props.routeModel.start = start;
            if (snapped) {
                this.props.routeModel['snapPoint'] = snapped.snapPoint;
            }
            this.props.trackLocationChanged(true);
            this.props.triggerNeedSave();
       
            (this.props.layername === 'ConstructionSegment') &&
                onCheckOverlapping(this.state.start, this.state.end);
        };

        const endState = (pos) => {
            const end = `${pos.lat}, ${pos.lng}`;
            this.setState({ end: end });
            this.props.routeModel.end = end;
            this.props.trackLocationChanged(true);
            this.props.triggerNeedSave();

            (this.props.layername === 'ConstructionSegment') &&
                onCheckOverlapping(this.state.start, this.state.end);
        };
        const textStyle = { color: 'red', fontSize: '15px' }

        const waypointState = (pos, id) => {
            const { waypoints } = this.state;
            console.log('%c updated waypoints ', 'color: #5EBA7D');
            console.log(id);
            console.log(pos);
            // eslint-disable-next-line
            waypoints[id] = [parseFloat(pos.lat), parseFloat(pos.lng)];
            this.setState({ waypoints: waypoints });
            this.props.routeModel.waypoints = waypoints;
            this.props.triggerNeedSave();
        }

        // write out waypoint stuff into the form.
        const waypoints = this.state.waypoints.map((p) => {
            const key = this.state.waypoints.indexOf(p);
            let wpDisplayVal = `${p[0]}, ${p[1]}`;
            return (
                <PtInputIconWaypoint key={key}
                    inputColor="pt-intent-primary"
                    disabled={this.props.disabled}
                    icon={<a className="grow pt-icon pt-icon-map-marker" style={{ color: '#106BA3' }}
                        onClick={() => {
                            onWaypointPlot(waypointState, key);
                        }}></a>}
                    button={<button className="pt-button pt-minimal pt-intent-primary pt-icon-cross"
                        onClick={() => { this.removeWaypoint(this.state.waypoints.indexOf(p)); }}></button>}
                    value={wpDisplayVal}
                    label={"Waypoint " + key} />
            );
        });

        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>
                    <div>
                        <PtInputShort inputType="hwy" label="Highway Number" name="hwyNum" disabled={this.props.disabled} value={this.state.hwyNum} placeholder="Highway #"
                            onChange={this.onInputChange} />

                        <Label color='blue' style={this.state.routeLength > 0 ? { display: 'inline', float: 'left', marginTop: 32 } : { display: 'none' }} basic size='mini'>
                            Length: {this.state.routeLength} Miles
                        </Label>
                    </div>

                    <PtInputIcon inputColor="pt-intent-success"
                        disabled={this.props.disabled}
                        icon={<a className="grow pt-icon pt-icon-map-marker"
                            onClick={() => {
                                onClickStart(startState);
                                if (typeof this.props.clickFunctions.loadConstructionHistory === 'function') {
                                    this.props.clickFunctions.loadConstructionHistory();
                                    this.props.clickFunctions.toggleCPLegend();
                                }
                            }}
                            style={{ color: '#0A6640' }}></a>}
                        value={this.state.start}
                        label="Start Location"
                        edit={<EditGeographicPoint originalCoords={this.state.start} updateCoordinate={(cp) => { onClickStart(startState, cp); this.props.triggerNeedSave(); }} />} />

                    <PtInputIcon inputColor="pt-intent-warning"
                        disabled={this.props.disabled}
                        icon={<a className="grow pt-icon pt-icon-map-marker"
                            onClick={() => {
                                onClickEnd(endState);
                                if (typeof this.props.clickFunctions.loadConstructionHistory === 'function') {
                                    this.props.clickFunctions.loadConstructionHistory();
                                    this.props.clickFunctions.toggleCPLegend();
                                }
                            }}
                            style={{ color: '#A66321' }}></a>}
                        value={this.state.end}
                        label="End Location"
                        edit={<EditGeographicPoint originalCoords={this.state.end} updateCoordinate={(cp) => { onClickEnd(endState, cp); this.props.triggerNeedSave(); }} />} />
                    {this.props.layername === 'ConstructionSegment' && <p style={textStyle}> Ensure Segments do not overlap!</p>}
                    {this.props.layername === 'OwnerLoadLimits' && <p style={textStyle}> Ensure Segments do not overlap!</p>}

                    {this.state.isPolyLine &&
                        <Label color='green' basic size='mini'>Is PolyLine</Label>
                    }

                    <Accordion fluid>
                        <Accordion.Title className="accordion-title">
                            <Icon name='dropdown' />
                            Waypoints
                        </Accordion.Title>
                        <Accordion.Content>
                            <div className="pt-input-group pt_inputIcon_width pt-fill" style={{ height: 40 }}>
                                {this.state.waypoints.length <= this.state.limitPoints &&
                                    <button type="button" disabled={this.props.disabled}
                                        className="pt-button pt-icon-add pt-icon-map-marker pt-intent-primary"
                                        onClick={this.addWaypoint}>
                                        New Waypoint</button>
                                }
                            </div>
                            {waypoints}
                        </Accordion.Content>
                    </Accordion>

                    <PtInput label="Segment Description" disabled={this.props.disabled} value={this.state.segDesc} placeholder="Segment Description"
                        onChange={this.onInputChange} name="segDesc" />
                    {/*<Checkbox disabled={this.props.disabled} checked={this.state.isPolyLine} label="Is Polyline" onChange={this.onIsPolyChanged} />*/}
                    {!this.state.isPolyLine &&
                        (
                            <Modal trigger={<Button size='mini' color='green' disabled={this.props.disabled} content="Convert To PolyLine" onClick={() => { this.setState({ triggerIsPolyModal: true }) }} />}
                                basic size='small'
                                open={this.state.triggerIsPolyModal}
                                onClose={() => { this.setState({ triggerIsPolyModal: false }) }}>
                                <Header icon='archive' content='Convert To PolyLine Warning!' />
                                <Modal.Content>
                                    <p>This will convert the route to a poly line, you can not undo this change. Would you like to continue?</p>
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button basic color='red' inverted onClick={() => { this.setState({ triggerIsPolyModal: false }) }}>
                                        <Icon name='remove' /> No
                                    </Button>
                                    <Button color='green' inverted onClick={this.onIsPolyChanged}>
                                        <Icon name='checkmark' /> Yes
                                    </Button>
                                </Modal.Actions>
                            </Modal>
                        )
                    }
                </ScrollArea>
            </Container>
        );
    }

    onInputChange = (e) => {
        const { name, value } = e.target;
        this.props.triggerNeedSave();
        this.setState({ [name]: value });
        this.props.routeModel[name] = value;
    }

    onIsPolyChanged = () => {
        const res = !this.state.isPolyLine;
        this.setState({ isPolyLine: res });
        this.props.routeModel["isPolyLine"] = res;
        this.props.triggerNeedSave();
        this.props.clickFunctions.onPolyLineTick(res);
    }


    addWaypoint = () => {
        const key = this.state.waypoints.length;
        const waypointState = (pos, id) => {
            const { waypoints } = this.state;
            waypoints.push([pos.lat.toFixed(5), pos.lng.toFixed(5)]);
            this.setState({ waypoints: waypoints });
            this.props.routeModel.waypoints = waypoints;
        }

        this.props.clickFunctions.onWaypointPlot(waypointState, key);
        this.props.triggerNeedSave();
    }

    removeWaypoint = (id) => {
        const { waypoints } = this.state;
        waypoints.splice(id, 1);
        this.props.clickFunctions.onWaypointSplice(id);
        this.setState({
            waypoints: waypoints
        });
        this.props.routeModel.waypoints = waypoints;
        this.props.triggerNeedSave();
    }

}


// WEBPACK FOOTER //
// ./src/layers/tabs/route-tab.js